module.exports = __webpack_public_path__ + "static/media/1build-logo.560b40d1.png";